document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("promo-popup-overlay");
    const close = document.getElementById("promo-popup-close");
    const button = popup
        ? popup.querySelector(".promo-popup-button")
        : null;

    if (!popup) return;

    const STORAGE_KEY = "promoPopupSeen";

    /*
     * ==========================================
     * REVISAR SI YA FUE VISTO EN ESTA SESIÓN
     * ==========================================
     */

    if (sessionStorage.getItem(STORAGE_KEY)) {
        return;
    }


    /*
     * ==========================================
     * MOSTRAR POPUP DESPUÉS DE 3 SEGUNDOS
     * ==========================================
     */

    setTimeout(function () {

        popup.style.display = "flex";

        popup.animate(
            [
                {
                    opacity: 0,
                    transform: "scale(.97)"
                },
                {
                    opacity: 1,
                    transform: "scale(1)"
                }
            ],
            {
                duration: 300,
                easing: "ease-out"
            }
        );

    }, 3000);


    /*
     * ==========================================
     * CERRAR CON LA X
     * ==========================================
     */

    if (close) {

        close.addEventListener("click", function () {

            popup.style.display = "none";

            // No volver a mostrar durante esta sesión
            sessionStorage.setItem(
                STORAGE_KEY,
                "true"
            );

        });

    }


    /*
     * ==========================================
     * BOTÓN "COMPRAR AHORA"
     * ==========================================
     */

    if (button) {

        button.addEventListener("click", function () {

            // Marcar como visto antes de navegar
            sessionStorage.setItem(
                STORAGE_KEY,
                "true"
            );

            // Ocultar inmediatamente
            popup.style.display = "none";

        });

    }


    /*
     * ==========================================
     * CERRAR AL HACER CLIC FUERA
     * ==========================================
     */

    popup.addEventListener("click", function (event) {

        if (event.target === popup) {

            popup.style.display = "none";

            sessionStorage.setItem(
                STORAGE_KEY,
                "true"
            );

        }

    });

});